interface Config {
  apiUrl: string | undefined;
  stripeKey: string | undefined;
}
const config: Config = {
  apiUrl    : import.meta.env.VITE_APP_API_URL,
  stripeKey : import.meta.env.VITE_APP_STRIPE_KEYS,
};

export default config;
